import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgSpinnerComponent } from './pg-spinner.component';

@NgModule({
  imports: [CommonModule],
  declarations: [PgSpinnerComponent],
  exports: [PgSpinnerComponent],
})
export class PgSpinnerModule {}
